var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tag',{attrs:{"type":_vm.type,"size":"is-small"}},[_vm._t("actions",null,{"code":_vm.code})],2)}
var staticRenderFns = []

export { render, staticRenderFns }